import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo Cin7 connector (Komodo.SCM.Web/Controllers/Api/Cin7/*).
const enc = encodeURIComponent;

const instances = () => Client.get('/api/cin7-instance');
const createInstance = (dto) => Client.post('/api/cin7-instance', dto);
const updateInstance = (code, dto) =>
	Client.put(`/api/cin7-instance/${enc(code)}`, dto);

// Cin7SettingDTO { instances, deptContactMappings } — the save takes the whole document back.
const settings = () => Client.get('/api/cin7-setting/all');
const saveSettings = (dto) => Client.post('/api/cin7-setting', dto);
// Cin7BaseRequest: note the komodo field is spelled `intanceCode`.
const contacts = (instanceCode, searchText) =>
	Client.post('/api/cin7-setting/contacts/query-list', {
		intanceCode: instanceCode,
		rows: 10,
		where: searchText
			? `Company like '%${String(searchText).replace(/'/g, "''")}%'`
			: '',
	});

const tasks = (query) =>
	Client.post('/api/cin7-task/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);
// Cin7SyncTaskDTO { syncType, allOverrideTask, requestModifyTime } → SaveBillOperationResult
const addTask = (dto) => Client.post('/api/cin7-task', dto);
const taskItems = (taskID, searchText) =>
	Client.post('/api/cin7-task/details/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		taskID,
		searchText: searchText || '',
	}).then(pagerRows);
const retryItem = (taskId, taskSubID) =>
	Client.post('/api/cin7-task/details/retry', { taskId, taskSubID });

export default {
	instances,
	createInstance,
	updateInstance,
	settings,
	saveSettings,
	contacts,
	tasks,
	addTask,
	taskItems,
	retryItem,
};
